export default __webpack_public_path__ + "static/media/photo--sm--87.de635103.jpg";